import { useMediaQuery } from '@hooks/useMediaQuery'

import { breakpointSM } from '@theme/breakpoints.module.css'

export const useIsMobile = () => !useMediaQuery(`(min-width: ${breakpointSM})`)
